import React from "react";
import DataContext from "./DataContext";

const filterReducer = (state, action) => {
    switch (action.type) {
        case 'init_filters':
            return action.payload
        case 'change_filter':
            return { ...state, [action.name]: action.payload }
        case 'reset_state':
            return {}
        default:
            return state
    }
}

const initFilters = (dispatch) => {
    return (filters) => {
        dispatch({ type: 'init_filters', payload: filters })
    }
}

const changeFilterValue = (dispatch) => {
    return (name, filter) => {
        dispatch({ type: 'change_filter', name: name, payload: filter })
    }
}

const resetState = (dispatch) => {
    return () => {
        dispatch({ type: 'reset_state' })
    }
}

export const { Context, Provider } = DataContext(
    filterReducer,
    { initFilters, changeFilterValue, resetState },
    []
)